import {
  SECTION_A,
  SECTION_B,
  SECTION_C,
  SECTION_D,
  DEPARTMENT_KEYS,
  DEPARTMENT_LABELS,
  SURVEY_STEPS,
} from "./surveyData";

const API_BASE = process.env.REACT_APP_PORTAL_URL || "";
const API_ENABLED = API_BASE.length > 0;

// Shapes static data into the canonical survey structure that mirrors
// what Laravel GET /api/survey/structure will return.
const buildStaticStructure = () => ({
  steps: SURVEY_STEPS,
  departmentKeys: DEPARTMENT_KEYS,
  departmentLabels: DEPARTMENT_LABELS,
  sections: {
    A: SECTION_A,
    B: SECTION_B, // { hr: [...], finance: [...], ... }
    C: SECTION_C,
    D: SECTION_D,
  },
});

/**
 * GET /api/survey/structure
 *
 * Expected response shape:
 * {
 *   steps:           [{ key, label, shortLabel, count }, ...],
 *   departmentKeys:  { "A": "hr", "B": "finance", ... },
 *   departmentLabels:{ "hr": "HR / Talent Acquisition", ... },
 *   sections: {
 *     A: [{ id, code, text, type, options?, hint?, hasOther?, isDepartmentSelect? }, ...],
 *     B: { hr: [...], finance: [...], sales: [...], ... },
 *     C: [...],
 *     D: [...]
 *   }
 * }
 *
 * Falls back to static surveyData.js when REACT_APP_API_URL is not set.
 */
export const fetchSurveyStructure = async () => {
  // if (!API_ENABLED) return buildStaticStructure();
  try {
    const res = await fetch(`${API_BASE}/api/survey/structure`, {
      headers: { Accept: "application/json" },
    });
    if (!res.ok) throw new Error(`${res.status}`);
    return res.json();
  } catch (err) {
    console.warn("Survey structure API unavailable, using static data:", err.message);
    // return buildStaticStructure();
  }
};

/**
 * POST /api/survey/contact
 *
 * Request body:
 * { firstName, lastName, company, email, companySize }
 *
 * Expected response:
 * { submissionId: "uuid" }
 *
 * The returned submissionId ties the contact record to the eventual
 * survey submission in POST /api/survey/submit.
 */
export const submitContact = async (contactData) => {
  if (!API_ENABLED) return { submissionId: null };
  const res = await fetch(`${API_BASE}/api/survey/contact`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Accept: "application/json",
    },
    body: JSON.stringify(contactData),
  });
  if (!res.ok) throw new Error(`Contact submission failed (${res.status})`);
  return res.json();
};

/**
 * POST /api/survey/submit
 *
 * Request body:
 * {
 *   submissionId:  "uuid" | null,
 *   contact:       { firstName, lastName, company, email, companySize },
 *   department:    "hr" | "finance" | ... | null,
 *   answers:       { "a1": "B", "a2": "C", "a4": 4, "b_sal1": "D", ... },
 *   otherIndustry: "string" | null,
 *   completedAt:   "ISO-8601 datetime"
 * }
 *
 * Expected response:
 * { success: true }
 */
export const submitSurvey = async (payload) => {
  // if (!API_ENABLED) return { success: true };
  const res = await fetch(`${API_BASE}/api/survey/submit`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Accept: "application/json",
    },
    body: JSON.stringify(payload),
  });
  if (!res.ok) throw new Error(`Survey submission failed (${res.status})`);
  return res.json();
};
